
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick,
  PropType,
} from '@vue/composition-api';

interface SwiperBreakpoint {
  slidesPerView: number;
  spaceBetween: number;
}

interface SwiperBreakpoints {
  [key: number]: SwiperBreakpoint;
}

export default defineComponent({
  name: 'FCSwiperThumbs',
  props: {
    slidesPerView: {
      type: Number,
      default: 4,
    },
    spaceBetween: {
      type: Number,
      default: 10,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    thumbsPosition: {
      type: String as PropType<'left' | 'bottom' | 'right'>,
      default: 'bottom',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    breakpoints: {
      type: Object as PropType<SwiperBreakpoints>,
      default: null,
    },
    maxHeight: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const mainSwiperRef = ref<any>(null);
    const thumbsSwiperRef = ref<any>(null);
    const currentSlide = ref(0);
    const isMobile = ref(true);

    const updateDirection = () => {
      if (typeof window !== 'undefined') {
        isMobile.value = window.innerWidth < 768;
        let direction = 'horizontal';
        if (!isMobile.value && (props.thumbsPosition === 'left' || props.thumbsPosition === 'right')) {
          direction = 'vertical';
        }

        if (thumbsSwiperRef.value?.swiper) {
          thumbsSwiperRef.value.swiper.changeDirection(direction);
        }
      }
    };

    onMounted(async () => {
      await nextTick();

      const swiperEl = mainSwiperRef.value;
      if (swiperEl?.swiper) {
        currentSlide.value = swiperEl.swiper.realIndex;

        swiperEl.swiper.on('slideChange', () => {
          currentSlide.value = swiperEl.swiper.realIndex;
        });
      }

      updateDirection();
      window.addEventListener('resize', updateDirection);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateDirection);
    });

    return {
      mainSwiperRef,
      thumbsSwiperRef,
      currentSlide,
      isMobile,
    };
  },
});
